import { Application } from "./application";
import { Company } from "./company";
import { Material } from "./material";
import { Ship } from "./ship";
import { Site } from "./site";

export class Tonnage {
    id?: string;
    siteId?: string | null;
    site?: Site;
    companyId?: string | null;
    company?: Company;
    date?: Date | string;
    quantity?: number
    isLoading?: boolean;
    isExceptionalConvoy?: boolean;
    shipName?: string;
    origineName?: string;
    destinationName?: string;
    orderReference?: string;
    materialId?: string | null;
    material?: Material;
    applicationId?: string | null;
    application?: Application;
    billed?: boolean;
    processed?: boolean;
    creationDate?: Date | string;
    isError?: boolean;

    origineSiteId?: string | null;
    origineSite?: Site;
    destinationSiteId?: string | null;
    destinationSite?: Site;

    shipId?: string | null;
    ship?: Ship;

    constructor(tonnage?: Tonnage) {
        this.id = tonnage?.id;
        this.siteId = tonnage?.siteId || (tonnage?.site ? tonnage?.site.id : null);
        this.site = tonnage?.site;
        this.companyId = tonnage?.companyId || (tonnage?.company ? tonnage?.company.id : null);
        this.company = tonnage?.company;
        this.date = tonnage?.date;
        this.quantity = tonnage?.quantity;
        this.isLoading = tonnage?.isLoading;
        this.isExceptionalConvoy = tonnage?.isExceptionalConvoy;
        this.shipName = tonnage?.shipName;
        this.origineName = tonnage?.origineName;
        this.destinationName = tonnage?.destinationName;
        this.orderReference = tonnage?.orderReference;
        this.materialId = tonnage?.materialId || (tonnage?.material ? tonnage?.material.id : null);
        this.material = tonnage?.material;
        this.applicationId = tonnage?.applicationId || (tonnage?.application ? tonnage?.application.id : null);
        this.application = tonnage?.application;
        this.billed = tonnage?.billed;
        this.processed = tonnage?.processed;
        this.creationDate = tonnage?.creationDate;
        this.isError = tonnage?.isError;
        this.origineSite = tonnage?.origineSite;
        this.origineSiteId = tonnage?.origineSiteId || (tonnage?.origineSite ? tonnage?.origineSite.id : null);
        this.destinationSite = tonnage?.destinationSite;
        this.destinationSiteId = tonnage?.destinationSiteId || (tonnage?.destinationSite ? tonnage?.destinationSite.id : null);
        this.ship = tonnage?.ship;
        this.shipId = tonnage?.shipId || (tonnage?.ship ? tonnage?.ship.id : null);
    }
}
